import React, { useEffect } from 'react'
import ImageOnly from './BlogSectionRendering/ImageOnly'
import TextAboveImage from './BlogSectionRendering/TextAboveImage';
import TextBelowImage from './BlogSectionRendering/TextBelowImage';
import TextLeftImage from './BlogSectionRendering/TextLeftImage';
import TextRightImage from './BlogSectionRendering/TextRightImage';
import TextOnly from './BlogSectionRendering/TextOnly';
import TextOverImage from './BlogSectionRendering/TextOverImage';
import LinkOnly from './BlogSectionRendering/LinkOnly';
import Accordian from './BlogSectionRendering/Accordion';
import ClientContainer from './ClientSection/ClientContainer';
import './BlogSectionRendering/Accordion.css';
import HtmlRawContainerBlogSection from './BlogSectionRendering/HtmlRawContainerBlogSection';

function renderSwitch(renderType, blogSectionObj, theme) {
  switch (renderType) {
    case 'ImageOnly':
      return <ImageOnly blogSectionObj={blogSectionObj} theme={theme}></ImageOnly>
    case 'TextAboveImage':
      return <TextAboveImage blogSectionObj={blogSectionObj} theme={theme}></TextAboveImage>
    case 'TextBelowImage':
      return <TextBelowImage blogSectionObj={blogSectionObj} theme={theme}></TextBelowImage>
    case 'TextOverImage':
      return <TextOverImage blogSectionObj={blogSectionObj} theme={theme}></TextOverImage>
    case 'TextRightImage':
      return <TextRightImage blogSectionObj={blogSectionObj} theme={theme}></TextRightImage>
    case 'TextLeftImage':
      return <TextLeftImage blogSectionObj={blogSectionObj} theme={theme}></TextLeftImage>
    case 'LinkOnly':
      return <LinkOnly blogSectionObj={blogSectionObj} theme={theme}></LinkOnly>
    case 'Accordion':
      return <Accordian blogSectionObj={blogSectionObj} theme={theme}></Accordian>
    case 'ClientPage':
      return <ClientContainer blogSectionObj={blogSectionObj} theme={theme}></ClientContainer>
    case 'rawHtml':
      return <HtmlRawContainerBlogSection blogSectionObj={blogSectionObj} theme={theme}></HtmlRawContainerBlogSection>
    default:
      return <TextOnly blogSectionObj={blogSectionObj} theme={theme}></TextOnly>;
  }
}
function BlogSection(props) {
  useEffect(() => {
    var hash = window.location.hash;
    if (hash) {
      var element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

  }, [])

  var blogSectionObj = props.blogSectionObj
  var renderType = blogSectionObj.attributes.renderType
  var theme = props.theme

  return (
    renderSwitch(renderType, blogSectionObj, theme)
  )
}

export default BlogSection
